<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-close`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.3684 3.7104C11.6265 3.53989 11.978 3.56906 12.2053 3.79634C12.432 4.02362 12.4606 4.37435 12.2902 4.63228L12.2043 4.73677L8.94062 7.99946L12.2053 11.2641L12.2902 11.3686C12.4605 11.6266 12.4323 11.9774 12.2053 12.2045C11.9782 12.4315 11.6274 12.4604 11.3693 12.2905L11.2648 12.2045L8.0002 8.93989L4.73555 12.2045L4.63105 12.2905C4.37302 12.4604 4.02214 12.4315 3.79512 12.2045C3.56813 11.9774 3.53994 11.6266 3.71016 11.3686L3.79512 11.2641L7.05879 7.99946L3.79609 4.73677L3.71016 4.63228C3.53979 4.37436 3.56837 4.02363 3.79512 3.79634C4.02238 3.56906 4.37389 3.53989 4.63203 3.7104L4.73555 3.79536L8.0002 7.05903L11.2648 3.79536L11.3684 3.7104Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineClose',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
